import React, { useContext, useState } from 'react';
import { Menu, MenuItem, IconButton, Tooltip } from '@mui/material';
import { ThemeContext } from 'src/theme/index';
import { Brightness4, WbSunnyOutlined, SettingsBrightness, BedtimeOutlined } from '@mui/icons-material';

export default function ThemeToggleButton() {
  const { themeMode, changeThemeMode } = useContext(ThemeContext);
  const [anchorEl, setAnchorEl] = useState(null);

  // Open/close the menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Change the theme mode
  const handleThemeChange = (mode) => {
    changeThemeMode(mode);
    handleClose();
  };

  return (
    <>
      <Tooltip title="Changer le thème">
        <IconButton
          onClick={handleClick}
          color="inherit"
          aria-label="toggle theme"
        >
          {themeMode === 'light' ? <WbSunnyOutlined /> : themeMode === 'dark' ? <Brightness4 /> : <SettingsBrightness />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiMenuItem-root': {
              typography: 'body1',
              borderRadius: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={() => handleThemeChange('light')}>
          <WbSunnyOutlined style={{ marginRight: 8 }} /> Clair
        </MenuItem>
        <MenuItem onClick={() => handleThemeChange('dark')}>
          <BedtimeOutlined style={{ marginRight: 8 }} /> Sombre
        </MenuItem>
        <MenuItem onClick={() => handleThemeChange('system')}>
          <SettingsBrightness style={{ marginRight: 8 }} /> Système
        </MenuItem>
      </Menu>
    </>
  );
}
